import Vue from 'vue'
import de from '../langs/de'
import en from '../langs/en'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'de',
    fallbackLocale: 'en',
    messages: {
        de, en
    }
})